import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

type TooltipContentResolverDeps = {
  tooltipText: string;
  translateService: TranslateService;
  sanitizer: DomSanitizer;
  allowHtml: boolean;
};

const TRANSLATION_KEY_PATTERN = /^[A-Z0-9_]+(?:\.[A-Z0-9_]+)+$/;

function shouldTranslateTooltipContent(content: string): boolean {
  return TRANSLATION_KEY_PATTERN.test(content.trim());
}

export function resolveTooltipContent({
  tooltipText,
  translateService,
  sanitizer,
  allowHtml,
}: TooltipContentResolverDeps): string {
  let content = tooltipText;

  if (shouldTranslateTooltipContent(content)) {
    const translated = translateService.instant(content);
    content = translated !== content ? translated : content;
  }

  if (!allowHtml) {
    return content;
  }

  return sanitizer.sanitize(SecurityContext.HTML, content) ?? '';
}
